import { EventEmitter, Injectable, Output } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
  
  export class SettingsfileService {
    @Output()
    updatedLocalhostValues: EventEmitter<any> = new EventEmitter(true);

  }